import './notificationlistitem.scss';
import { FormattedMessage } from 'react-intl';
import LabeledString from '../../../sharedmodules/components/labeled-string';
import PropTypes from 'prop-types';
import React from 'react';
import { buildDate } from '../../../sharedmodules/services/build-date';

const NotificationItemList = ({
    item,
    editNotificationHander, deleteNotification,
}) => (
    <div className="notificationlist">
        <section className="notification-list-details">
            {
                item.title && (
                    <div className="row">
                        <h6>{item.title}</h6>
                    </div>
                )
            }
            {
                item.shortText && <span>{item.shortText}</span>
            }
            {
                item.url && (
                    <div className="row notification-url">
                        <span><a label="url-details" href={item.url} target="blank"><FormattedMessage id="CLICK_FOR_DETAILS" /></a></span>
                    </div>
                )
            }
            <footer>
                <section>
                    <div>
                        <LabeledString
                            className="created-by"
                            data={item.createdBy ? item.createdBy : ''}
                            label="CREATED_BY"
                        />
                        <LabeledString
                            className="created-on"
                            data={buildDate(item.createdAt)}
                            label="CREATED"
                        />
                    </div>
                    <div>
                        <LabeledString
                            className="updated-by"
                            data={item.updatedBy ? item.updatedBy : ''}
                            label="UPDATED_BY"
                        />
                        <LabeledString
                            className="updated-on"
                            data={buildDate(item.updatedAt)}
                            label="UPDATED"
                        />
                    </div>
                    <div className="actionButton">
                        <button
                            type="button"
                            className="secondary"
                            onClick={() => {

                                deleteNotification(item.id);

                            }}
                        >
                            <FormattedMessage id="DELETE" />
                        </button>
                        <button
                            type="button"
                            className="button-primary"
                            onClick={() => {

                                editNotificationHander(item);

                            }}
                        >
                            <FormattedMessage id="EDIT" />
                        </button>
                    </div>
                </section>
            </footer>
        </section>
    </div>
);

NotificationItemList.propTypes = {
    item: PropTypes.object,
    editNotificationHander: PropTypes.func,
    deleteNotification: PropTypes.func,
};

export default NotificationItemList;
